var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgStarGoldWhiteBorder = function SvgStarGoldWhiteBorder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.89 1.376a1.452 1.452 0 012.22 0l.116.158 1.277 2.02 2.316.592.186.06a1.451 1.451 0 01.686 2.112l-.115.159-1.526 1.837.154 2.387v.195a1.451 1.451 0 01-1.797 1.306l-.186-.06L7 11.258l-2.22.884a1.45 1.45 0 01-1.984-1.44l.153-2.388-1.525-1.837a1.45 1.45 0 01.757-2.331l2.315-.591 1.278-2.02.116-.159z",
    fill: "#D4BB5E",
    stroke: "#fff",
    strokeWidth: 1.5
  })));
};
export default SvgStarGoldWhiteBorder;